import { render, staticRenderFns } from "./rich.vue?vue&type=template&id=6be15df8&"
import script from "./rich.vue?vue&type=script&lang=js&"
export * from "./rich.vue?vue&type=script&lang=js&"
import style0 from "./rich.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports